// @flow

import { handleActions } from 'redux-actions';
import { REDUCER_KEY as FF_REDUCER_KEY, mkFeatureFlagsStore } from 'utils/featureFlags/types';
import { completeWithError } from 'data/qcsSyncResourceReducerHelpers';

import * as actions from './actions';


const reducer = handleActions({
  [actions.getFlags]: (state) => state.merge({
    isLoading: true,
    error: undefined,
  }),

  [actions.getFlagsSuccess]: (state, {payload: flags}) => {
    const featureFlags = state.featureFlags.withMutations((map) => Object.entries(flags).forEach(([key, value]) => map.set(key, value)));
    window.dangerouslyUseFeatureFlags = featureFlags;
    return state.merge({
      featureFlags,
      isLoading: false,
      loadPending: false,
      error: undefined,
    });
  },

  [actions.getFlagsFailure]: (state, { payload: error }) => completeWithError(state, error),

  [actions.setFlags]: (state, {payload: flags}) => {
    const featureFlags = state.featureFlags.withMutations((map) => Object.entries(flags).forEach(([key, value]) => map.set(key, value)));
    window.dangerouslyUseFeatureFlags = featureFlags;
    return state.merge({ featureFlags });
  },

  [actions.setFlagsMeta]: (state, { payload: meta }) => state.merge(meta),

  [actions.setFlag]: (state, { payload: flag }) => {
    const featureFlags = state.featureFlags.set(flag.key, flag.value);
    window.dangerouslyUseFeatureFlags = featureFlags;
    return state.merge({ featureFlags });
  },

}, mkFeatureFlagsStore());

export const REDUCER_KEY = FF_REDUCER_KEY;
export default reducer;
